import FolderIcon from "@material-ui/icons/Folder";
import InsertChartIcon from "@material-ui/icons/InsertChart";
import { DragLayerMonitorProps } from "@minoru/react-dnd-treeview";
import React from "react";
import { TagFromTree } from "../../../models/TagsTree.model";
import { useTagsTreeModalStyles } from "../../../styles/TasgTreeModalStyles";

type Props = {
	monitorProps: DragLayerMonitorProps<TagFromTree>;
};

export const CustomDragPreview: React.FC<Props> = (props) => {
	const classes = useTagsTreeModalStyles();

	const item = props.monitorProps.item;
	const isFolder = item.data?.TagTypeCode === "F" ? true : false;

	return (
		<div className={classes.customDragRoot}>
			<div className={classes.icon}>
				{isFolder ? <FolderIcon /> : <InsertChartIcon fontSize="small" />}
			</div>
			<div className={classes.customDragLabel}>
				{item.data?.Alias || item.data?.TagName}
			</div>
		</div>
	);
};
